"use strict";
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.ContentRow = void 0;
var _mui = require("@ori-ui/mui");
var _auth = require("@ori/auth");
var _featureToggles = require("@ori/feature-toggles");
var _logger = require("@ori/logger");
var _presentationComponents = require("@ori/presentation-components");
var _productBox = require("@ori/product-box");
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _constants = require("../../../../constants");
var _utils = require("../../../../containers/SearchResultsPage/utils");
var _contexts = require("../../../../contexts");
var _utils2 = require("../../../../utils");
var _PromoBanner = require("../../../PromoBanner");
var _utilts = require("../../../PromoBanner/utilts");
var _constants2 = require("../../constants");
var _jsxRuntime = require("react/jsx-runtime");
const ContentRow = (param)=>{
    let { data } = param;
    const logger = (0, _logger.useLogger)('ContentRow');
    const { isAnonymousUser } = (0, _auth.useToken)();
    const { getTestId } = (0, _testidGenerator.default)();
    const { productBoxConfiguration, placement } = (0, _contexts.useProductListingContext)();
    const { isPLP, query } = (0, _contexts.useBannerProductListingContext)();
    const { isFeatureEnabled } = (0, _featureToggles.useFeatureToggles)();
    return data === null || data === void 0 ? void 0 : data.content.map((content, index)=>{
        var _content_banner_modules, _content_banner;
        if ((content === null || content === void 0 ? void 0 : content.__typename) === 'Product') {
            var _productBoxData_price;
            const productBoxData = (0, _productBox.mapProductBoxPropsFromGql)({
                data: content,
                isAnonymousUser,
                logger
            });
            if ((productBoxData === null || productBoxData === void 0 ? void 0 : productBoxData.code) && productBoxData.name && ((_productBoxData_price = productBoxData.price) === null || _productBoxData_price === void 0 ? void 0 : _productBoxData_price.currentFormatted)) {
                const url = (0, _utils2.addParamsToUrl)({
                    placement,
                    url: productBoxData.url,
                    params: (isPLP !== null && isPLP !== void 0 ? isPLP : !query) ? {} : {
                        [_utils.QUERY_NAME]: query
                    }
                });
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_productBox.ProductBox, {
                    ...productBoxData,
                    url: url,
                    labels: (0, _productBox.mapLabels)(content.labels, isPLP ? undefined : {
                        deal: [
                            _presentationComponents.OFFER
                        ]
                    }),
                    analyticsData: {
                        placement,
                        position: index
                    },
                    hideRating: !productBoxConfiguration.isRatingsAndReviewsEnabled,
                    hideSubscription: !isFeatureEnabled(_constants.PLPFeature.PersonalSubscriptions) || !productBoxConfiguration.isSubscriptionEnabled,
                    withTranslationsProvider: false,
                    mrpStatementEnabled: productBoxConfiguration.isMrpStatementEnabled
                }, productBoxData.code);
            }
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Box, {
                "data-testid": getTestId(_constants2.EMPTY_BOX)
            }, index);
        }
        if ((content === null || content === void 0 ? void 0 : content.__typename) === 'EditorialPlpPromoBanner' && ((_content_banner = content.banner) === null || _content_banner === void 0 ? void 0 : (_content_banner_modules = _content_banner.modules) === null || _content_banner_modules === void 0 ? void 0 : _content_banner_modules[0])) {
            var _module_backgroundImage, _module_content, _module_link, _module_backgroundVideo, _module_content1, _module_content2, _module_backgroundImage1, _module_backgroundImage2, _module_backgroundVideo1, _module_content3;
            const module = content.banner.modules[0];
            if (!((_module_backgroundImage = module.backgroundImage) === null || _module_backgroundImage === void 0 ? void 0 : _module_backgroundImage.url) && !((_module_content = module.content) === null || _module_content === void 0 ? void 0 : _module_content.title) && !((_module_link = module.link) === null || _module_link === void 0 ? void 0 : _module_link.relativeUrl) && !((_module_backgroundVideo = module.backgroundVideo) === null || _module_backgroundVideo === void 0 ? void 0 : _module_backgroundVideo.id)) {
                return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_mui.Box, {
                    "data-testid": getTestId(_constants2.EMPTY_BOX),
                    width: _constants2.BANNER_SIZE_IN_PX[content.size]
                }, index);
            }
            var _module_backgroundImage_url, _ref;
            return /*#__PURE__*/ (0, _jsxRuntime.jsx)(_PromoBanner.PromoBanner, {
                link: module.link,
                title: (_module_content1 = module.content) === null || _module_content1 === void 0 ? void 0 : _module_content1.title,
                caption: (_module_content2 = module.content) === null || _module_content2 === void 0 ? void 0 : _module_content2.caption,
                backgroundVideo: module.backgroundVideo,
                backgroundImage: (_module_backgroundImage1 = module.backgroundImage) === null || _module_backgroundImage1 === void 0 ? void 0 : _module_backgroundImage1.url,
                size: content.size,
                backgroundStorybookColor: module.backgroundStorybookColor,
                promoBannerType: (0, _utilts.getPromoBannerType)(content.banner)
            }, (_ref = (_module_backgroundImage_url = (_module_backgroundImage2 = module.backgroundImage) === null || _module_backgroundImage2 === void 0 ? void 0 : _module_backgroundImage2.url) !== null && _module_backgroundImage_url !== void 0 ? _module_backgroundImage_url : (_module_backgroundVideo1 = module.backgroundVideo) === null || _module_backgroundVideo1 === void 0 ? void 0 : _module_backgroundVideo1.id) !== null && _ref !== void 0 ? _ref : (_module_content3 = module.content) === null || _module_content3 === void 0 ? void 0 : _module_content3.title);
        }
        return null;
    });
};
exports.ContentRow = ContentRow;
